export default "__VITE_ASSET__C3Nug4Oq__"